import { axios } from '@/utils/request'

const api = {
    getTaobaoOrderList: '/5caf22f33b600', 
    getJingdongOrderList: '/5cb0037ad62f5',
    getPinduoduoOrderList: '/5cb00653c9f3f',
    updateOrderReplaceUid: '/5cbebc6e0398f'
}

export default {
    // 获取淘宝订单列表
    getTaobaoOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getTaobaoOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取京东订单列表
    getJingdongOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getJingdongOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取拼多多订单列表
    getPinduoduoOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getPinduoduoOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 订单换绑
    updateOrderReplaceUid: ({robotid, orderid, uid})=> {
        const params = {
            sub_id: robotid,
            order_id: orderid,
            uid: uid
        }
        return axios({
            url: api.updateOrderReplaceUid,
            method: 'post',
            data: params
        })
    }
}
